import axios from 'axios'
import { VERIFICAR_PAGAMENTO_SICOOB_ENCOMENDA_AVULSA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions'

// situação do pagamento Sicoob PIX da encomenda avulsa (polling até APROVADO/CANCELADO)
export default function verificarPagamentoSicoobEncomendaAvulsa (idEncomendaAvulsa) {
  const url = `${URL}/encomendas-avulsas/${idEncomendaAvulsa}/forma-pagamento/sicoob/status`
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: VERIFICAR_PAGAMENTO_SICOOB_ENCOMENDA_AVULSA,
      payload: response
    })
  )
}
